<app-tree-toolbar [currentTree]="tree" *ngIf="readFunction">
</app-tree-toolbar>

<app-tree-categories (currentTreeOutput)="receiveDataTree($event)" [updateFunction]="updateFunction"></app-tree-categories>
